import platform from 'platform';
import * as cookies from './Cookies';
import * as apiWrapper from './APIWrapper';

/**
 * subscribe
 */
export function subscribe(action) {

  window.onerror = (msg, file, line, col, error) => {

    const loginId = cookies.getItem('userId');

    let stack;
    if (error) {
      stack = error.stack;
    } else {
      stack = '';
    }

    const params =
      {
        message: msg,
        location: file.split('?')[0],
        at_line: line,
        at_col: col,
        occurred_at: new Date(),
        stack_trace: stack,
        user_id: loginId,
        user_agent: platform.description,
        os_info: platform.os,
        screen_size:
          {
            width: screen.width,
            height: screen.height
          },
        window_size:
          {
            width: window.innerWidth,
            height: window.innerHeight
          }
      };

    // 空の要素を削除
    for (let key in params) {
      if (!params[key]) {
        delete params[key];
      }
    }

    // REST API呼出処理
    apiWrapper.postServiceErrors(params);

    // エラー画面に遷移
    action.onScriptError();
  };
}

/**
 * cancel
 */
export function cancel() {
  window.onerror = null;
}
